// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__lynTH","nav__link":"Nav_nav__link__XDuoq","nav__link_active":"Nav_nav__link_active__o54Zd"};